import { create } from 'zustand';
import type { EchoMission, EchoMissionDetail } from '@vtak/shared';

interface LivekitState {
  token: string;
  wsUrl: string;
  channelId: number;
}

interface MissionsState {
  missions: EchoMission[];
  selectedDetail: EchoMissionDetail | null;
  livekit: LivekitState | null;
  listening: boolean;
  audioError: string | null;
  setMissions: (missions: EchoMission[]) => void;
  setSelectedDetail: (detail: EchoMissionDetail | null) => void;
  setLivekit: (token: string, wsUrl: string, channelId: number) => void;
  clearLivekit: () => void;
  setListening: (listening: boolean) => void;
  setAudioError: (error: string | null) => void;
}

/** Store for Echo mission list, selected detail, and LiveKit audio state */
export const useMissionsStore = create<MissionsState>((set) => ({
  missions: [],
  selectedDetail: null,
  livekit: null,
  listening: false,
  audioError: null,
  setMissions: (missions) => set({ missions }),
  setSelectedDetail: (detail) => set({ selectedDetail: detail }),
  setLivekit: (token, wsUrl, channelId) =>
    set({ livekit: { token, wsUrl, channelId }, listening: false, audioError: null }),
  clearLivekit: () =>
    set({ livekit: null, listening: false, audioError: null }),
  setListening: (listening) => set({ listening }),
  setAudioError: (error) => set({ audioError: error }),
}));
